import headerBg from '@/assets/images/active/snail/header/header_bg5.png';
import headerBg2 from '@/assets/images/active/snail/header/header_bg2.png';
import officeBtn from '@/assets/images/active/snail/header/btn_05.png';
import loginBtn from '@/assets/images/active/snail/header/btn_06.png';
import accountBtn from '@/assets/images/active/snail/header/btn_07.png';
import activeBtn from '@/assets/images/active/snail/header/btn_09.png';
import logoutBtn from '@/assets/images/active/snail/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: ''
  },
  logged_in: {
    background_image: headerBg,
    main_title_color: '#755013',
    sub_title_color: '#755013',
    tips_color: '#5679d0',
    game_name: '最强蜗牛',
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      link: 'https://snail.qingcigame.com/official/index_mobile.html'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: ''
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: ''
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: '',
      link: ''
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: ''
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/snail/anniversary/headerConfig.js